import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import { get, post, put, del } from "../helpers/apiHelper";
export var fetchAlerts = function fetchAlerts(_ref) {
  var apiBaseUrl = _ref.apiBaseUrl,
      pathprefix = _ref.pathprefix,
      accessTokenApiPath = _ref.accessTokenApiPath,
      payload = _ref.payload;
  return get({
    apiBaseUrl: apiBaseUrl,
    accessTokenApiPath: accessTokenApiPath,
    pathprefix: pathprefix,
    reqPath: "alerts",
    payload: payload
  });
};
export var fetchAlertsType = function fetchAlertsType(_ref2) {
  var apiBaseUrl = _ref2.apiBaseUrl,
      pathprefix = _ref2.pathprefix,
      accessTokenApiPath = _ref2.accessTokenApiPath;
  return get({
    apiBaseUrl: apiBaseUrl,
    accessTokenApiPath: accessTokenApiPath,
    pathprefix: pathprefix,
    reqPath: "alertSchemas"
  });
};
export var viewAlert = function viewAlert(_ref3) {
  var apiBaseUrl = _ref3.apiBaseUrl,
      pathprefix = _ref3.pathprefix,
      accessTokenApiPath = _ref3.accessTokenApiPath,
      payload = _ref3.payload;
  return put({
    apiBaseUrl: apiBaseUrl,
    accessTokenApiPath: accessTokenApiPath,
    pathprefix: pathprefix,
    reqPath: "alerts",
    payload: payload
  });
};
export var getAlertSubscriptions = function getAlertSubscriptions(_ref4) {
  var apiBaseUrl = _ref4.apiBaseUrl,
      pathprefix = _ref4.pathprefix,
      accessTokenApiPath = _ref4.accessTokenApiPath,
      payload = _ref4.payload;
  return get({
    apiBaseUrl: apiBaseUrl,
    pathprefix: pathprefix,
    reqPath: "alertSubscriptions",
    payload: payload,
    accessTokenApiPath: accessTokenApiPath
  });
};
export var getAlertsCount = function getAlertsCount(_ref5) {
  var _get;

  var apiBaseUrl = _ref5.apiBaseUrl,
      pathprefix = _ref5.pathprefix,
      accessTokenApiPath = _ref5.accessTokenApiPath,
      payload = _ref5.payload;
  return get((_get = {
    apiBaseUrl: apiBaseUrl,
    pathprefix: pathprefix
  }, _defineProperty(_get, "pathprefix", pathprefix), _defineProperty(_get, "reqPath", "alerts/getCount"), _defineProperty(_get, "payload", payload), _defineProperty(_get, "accessTokenApiPath", accessTokenApiPath), _get));
};
export var createAlertSubscriptions = function createAlertSubscriptions(_ref6) {
  var _post;

  var apiBaseUrl = _ref6.apiBaseUrl,
      pathprefix = _ref6.pathprefix,
      accessTokenApiPath = _ref6.accessTokenApiPath,
      payload = _ref6.payload;
  return post((_post = {
    apiBaseUrl: apiBaseUrl,
    pathprefix: pathprefix
  }, _defineProperty(_post, "pathprefix", pathprefix), _defineProperty(_post, "reqPath", "alertSubscriptions"), _defineProperty(_post, "service", "eventmanagement"), _defineProperty(_post, "payload", payload), _defineProperty(_post, "accessTokenApiPath", accessTokenApiPath), _post));
};
export var deleteAlertSubscriptions = function deleteAlertSubscriptions(_ref7) {
  var apiBaseUrl = _ref7.apiBaseUrl,
      pathprefix = _ref7.pathprefix,
      accessTokenApiPath = _ref7.accessTokenApiPath,
      payload = _ref7.payload;
  return del({
    apiBaseUrl: apiBaseUrl,
    pathprefix: pathprefix,
    reqPath: "alertSubscriptions",
    service: "eventmanagement",
    payload: payload,
    accessTokenApiPath: accessTokenApiPath
  });
};
export var updateAlertSubscriptions = function updateAlertSubscriptions(_ref8) {
  var apiBaseUrl = _ref8.apiBaseUrl,
      pathprefix = _ref8.pathprefix,
      accessTokenApiPath = _ref8.accessTokenApiPath,
      payload = _ref8.payload;
  return put({
    apiBaseUrl: apiBaseUrl,
    pathprefix: pathprefix,
    reqPath: "alertSubscriptions",
    service: "eventmanagement",
    payload: payload,
    accessTokenApiPath: accessTokenApiPath
  });
};
export var getAdminList = function getAdminList(_ref9) {
  var apiBaseUrl = _ref9.apiBaseUrl,
      pathprefix = _ref9.pathprefix,
      accessTokenApiPath = _ref9.accessTokenApiPath,
      payload = _ref9.payload;
  return get({
    apiBaseUrl: apiBaseUrl,
    pathprefix: pathprefix,
    reqPath: "listadmins",
    service: "common",
    payload: payload,
    accessTokenApiPath: accessTokenApiPath
  });
};
export var getUnseenAlertsCount = function getUnseenAlertsCount(_ref10) {
  var apiBaseUrl = _ref10.apiBaseUrl,
      pathprefix = _ref10.pathprefix,
      accessTokenApiPath = _ref10.accessTokenApiPath,
      payload = _ref10.payload;
  return get({
    apiBaseUrl: apiBaseUrl,
    accessTokenApiPath: accessTokenApiPath,
    pathprefix: pathprefix,
    reqPath: "alerts/getUnseenCount",
    service: "eventmanagement",
    payload: payload
  });
};
export var downloadAsCSV = function downloadAsCSV(_ref11) {
  var apiBaseUrl = _ref11.apiBaseUrl,
      pathprefix = _ref11.pathprefix,
      accessTokenApiPath = _ref11.accessTokenApiPath,
      payload = _ref11.payload;
  return get({
    apiBaseUrl: apiBaseUrl,
    accessTokenApiPath: accessTokenApiPath,
    pathprefix: pathprefix,
    reqPath: "alerts",
    payload: payload,
    optionalHeaders: {
      "Content-Type": "text/csv"
    }
  });
};